var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-pagination"},[_vm._v("···1页，共"+_vm._s(_vm.total)+"条···")])}
var staticRenderFns = []

export { render, staticRenderFns }